<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 詳細ダイアログの説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>詳細ダイアログの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/desc-dialog.png" width="100%">
        </div>
        <div class="manual-img">
          <img src="assets/img/manual/desc-dialog2.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 全言語自動翻訳
        </div>
        <div class="manual-explain">
          全言語の自動翻訳チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 全言語音声作成
        </div>
        <div class="manual-explain">
          全言語の音声作成チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 言語切り替え
        </div>
        <div class="manual-explain">
          クリックで設定する言語を切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 詳細（メイン言語）
        </div>
        <div class="manual-explain">
          表示用、翻訳用、音声用、それぞれの詳細を設定します。<br>
          <span class="manual-explain-notes">※必須項目</span><br>
          翻訳用に設定された内容をもとに各言語の翻訳を行います。<br>
          音声作成にチェックを入れることで、音声用に設定された内容をもとに音声生成が行われます。<br>
          <a [href]="projectDialogLink">プロジェクト情報：編集画面</a>で設定された言語の１番目のものがメイン言語となります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> 音声ファイル
        </div>
        <div class="manual-explain">
          音声ファイルが表示されます。<br>
          音声作成をシステムで行わない場合、ファイル選択から自身で用意した音声ファイルを設定可能です。<br>
          設定可能なファイルは、mp3 のみとなります。<br>
          ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> 詳細（他言語）
        </div>
        <div class="manual-explain">
          タブで選択中の言語の詳細（アプリ上の表示）と音声を設定します。<br>
          ▼詳細<br>
          　登録内容がアプリ上で表示されます。<br>
          　自動翻訳にチェックを入れた場合、<img src="assets/img/manual/F.png">の翻訳用詳細で設定された内容をもとに翻訳が行われます。（登録内容は翻訳処理によって上書きされます）<br>
          ▼音声用詳細<br>
          　音声作成にチェックを入れた場合、音声用詳細の登録内容をもとに音声ファイルを作成します（チェックを入れない場合は音声ファイルは作成されません）。<br>
          　同時に<img src="assets/img/manual/F.png">の音声作成にチェックが入っている場合は、そちらの音声用詳細で設定された内容をもとに翻訳が行われます。（登録内容は翻訳処理によって上書きされます）<br>
          　翻訳処理によって更新された内容をもとに音声ファイルを作成します。<br>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Detailed Dialog Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Detailed Dialog Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_desc-dialog.png" width="100%">
          </div>
          <div class="manual-img">
            <img src="assets/img/manual/en_desc-dialog2.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Update Button
          </div>
          <div class="manual-explain">
            Clicking this button applies the edited content.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Close Button
          </div>
          <div class="manual-explain">
            Clicking this button closes the dialog.<br>
            The selected content will not be applied.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Automatic Translation for All Languages
          </div>
          <div class="manual-explain">
            Toggles the ON/OFF state of the automatic translation checkbox for all languages.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Create Audio for All Languages
          </div>
          <div class="manual-explain">
            Toggles the ON/OFF state of the audio creation checkbox for all languages.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/E.png"> Language Switch
          </div>
          <div class="manual-explain">
            Click to switch the language to be set.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/F.png"> Details (Main Language)
          </div>
          <div class="manual-explain">
            Set the details for display, translation, and audio.<br>
            <span class="manual-explain-notes">* Required</span><br>
            Translations for each language will be based on the content set for translation.<br>
            When the audio creation checkbox is selected, audio will be generated based on the content set for audio.<br>
            The first language configured in the <a [href]="projectDialogLink">Project Information: Edit Screen</a> will be the main language.<br>
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/G.png"> Audio File
          </div>
          <div class="manual-explain">
            Displays the audio file.<br>
            If the system does not generate audio, you can set your own prepared audio file via file selection.<br>
            Only MP3 files are supported.<br>
            * The file must be pre-uploaded in the <a [href]="uploaderLink">Uploaded Files Screen</a>.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/H.png"> Details (Other Languages)
          </div>
          <div class="manual-explain">
          Set the details (displayed in the app) and audio for the language selected in the tab.<br>
          ▼Detail<br>
          　The registration details will be displayed on the app.<br>
          　If you check the automatic translation box, the translation will be performed based on the details set in the translation details in <img src="assets/img/manual/F.png">. (The registered details will be overwritten by the translation process.)<br>
          ▼Voice detail<br>
          　If you check Create Audio, an audio file will be created based on the registered audio details (if you do not check this, no audio file will be created).<br>
          　At the same time, if the voice creation option is checked, the translation will be based on the details set in the voice details. (The registered content will be overwritten by the translation process.)<br>
          　An audio file is created based on the content updated by the translation process.<br>
          </div>

        </mat-card-content>
      </mat-card>

  </div>

</div>